<template>
  <ValidationObserver ref="validator" tag="div">
      <template v-if="parentCategory === null || value.parentCategory.subCategories === null">
        <ValidationProvider :rules="{ required: true }" slim v-slot="{ errors, passed, failed }">
          <header class="lib__text-center">
            <h2 class="lib__h2">{{ $t('complaint.categorySelectorStep.sheConcerns') }}</h2>
          </header>
          <div :class="[failed && 'lib__field--error', passed && (value.description !== null && value.description !== '') && 'lib__field--valid']" class="lib__field">
            <TileRadio vertical v-for="(cat) in categories" :key="cat.key" group="parentCategory" :label="$t('complaint.category.' + cat.key)" required :item="cat.key" v-model="parentCategory">
            </TileRadio>
            <error-message :error="errors[0]"></error-message>
          </div>
        </ValidationProvider>
      </template>
      <template v-else>
        <header class="lib__text-center">
          <h2 class="lib__h2">{{ $t('complaint.categorySelectorStep.sheConcerns') }}</h2>
        <button type="button" class="lib__btn lib__btn--rounded lib__btn--dark lib__btn--outline" @click="parentCategory = null">
          <span>{{ $t(`complaint.category.${parentCategory}`) }}</span>
          <i class="fas fa-times"></i>
        </button>
        </header>
        <hr>
      </template>

      <div v-if="value !== null && value.parentCategory !== null && value.parentCategory.subCategories !== null">
        <ValidationProvider :rules="{ required: true }" slim v-slot="{ errors, passed, failed }">
          <header class="lib__text-center">
            <h2 class="lib__h2">{{ $t('complaint.categorySelectorStep.whatDoYouWish') }}</h2>
          </header>
          <div :class="[failed && 'lib__field--error', passed && (value.description !== null && value.description !== '') && 'lib__field--valid']" class="lib__field">
            <TileRadio vertical v-for="(cat) in value.parentCategory.subCategories" :key="cat.key" group="category" :label="$t('complaint.category.' + cat.key)" required :item="cat.key" v-model="category">
            </TileRadio>
            <error-message :error="errors[0]"></error-message>
          </div>
        </ValidationProvider>
      </div>

    <ModalDialog :open.sync="networkProblemsModalOpen">
      <p v-html="$t('complaint.categorySelectorStep.networkProblemsModal.content')" />
      <template #footer>
        <nav class="lib__btns-nav-list">
          <a
            class="lib__btn lib__btn--primary lib__btn--rounded"
            href="#"
            @click.prevent="networkProblemsModalOpen = false"
          >
            <span>{{ $t('complaint.categorySelectorStep.networkProblemsModal.btnText') }}</span>
          </a>
        </nav>
      </template>
    </ModalDialog>
  </ValidationObserver>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { Category, CategorySelectionStepModel } from '@/models';

@Component
export default class CategorySelector extends Vue {
  //#region [Property]
  @Prop({ required: true, type: Array }) public categories!: Category[];
  @Prop({ required: false, type: Object }) public value!: CategorySelectionStepModel | null;
  //#endregion

  //#region [Data]
  public networkProblemsModalOpen: boolean = false
  //#endregion

  //#region [Computed]
  public get parentCategory(): string | null {
      return this.value && this.value.parentCategory ? this.value.parentCategory.key : null;
  }

  public set parentCategory(val: string | null) {
    const cat = this.categories.find((c) => c.key === val) || null;
    this.change(cat, null);
    this.$validatorObs.reset();
  }

  public get category(): string | null {
      return this.value && this.value.category ? this.value.category.key : null;
  }

  public set category(val: string | null) {
    const cat = this.value!.parentCategory!.subCategories!.find((c) => c.key === val) || null;
    this.change(this.value!.parentCategory, cat);
  }

  //#endregion

  //#region [Emit]
    @Emit('input')
    public change(
      parentCategory: Category | null,
      category: Category | null
    ): CategorySelectionStepModel | null {
      return { parentCategory, category };
    }
  //#endregion

  //#region [Watch]
  @Watch('parentCategory')
  public onParentCategoryChanged(newVal: string | null) {
    this.networkProblemsModalOpen = newVal === 'networkProblems'
  }
  //#endregion
}
</script>
